export default __webpack_public_path__ + "static/media/bg-hero-parteneri.69bc5324.jpg";